import { render, staticRenderFns } from "./OutputFfa.vue?vue&type=template&id=4b64f06c&"
import script from "./OutputFfa.vue?vue&type=script&lang=js&"
export * from "./OutputFfa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports